import { render, staticRenderFns } from "./ThreeD.vue?vue&type=template&id=9449467c&scoped=true"
import script from "./ThreeD.vue?vue&type=script&lang=js"
export * from "./ThreeD.vue?vue&type=script&lang=js"
import style0 from "./ThreeD.vue?vue&type=style&index=0&id=9449467c&prod&lang=scss&scoped=true"
import style1 from "./ThreeD.vue?vue&type=style&index=1&id=9449467c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9449467c",
  null
  
)

export default component.exports